<template>
  <div>  <b-card-title class="text-center font-large-1">
           {{ $t('Researchers') }}
         </b-card-title>
    <b-card>
      <b-row>
        <b-col md="6">
          <b-row>
            <b-col
              v-for="key in ['all_confirmed', 'dc', 'phd', 'trainee']"
              :key="key"
              class="my-3"
              md="3"
            >
              <apply-doc-statistics-one-element-component
                :name="$langName(getName(key).name)"
                :count="applyDocCount[key]"
                :img-src="require(`@/assets/images/icons/phd/${key}.svg`)"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6">
          <b-row>
            <b-col
              v-for="key in ['i_dc','i_phd','t_dc', 't_phd']"
              :key="key"
              md="3"
              class="my-3"
            >
              <apply-doc-statistics-one-element-component
                :name="$langName(getName(key).name)"
                :count="applyDocCount[key]"
                :img-src="require(`@/assets/images/icons/phd/${key}.svg`)"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BCardTitle,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import ApplyDocStatisticsOneElementComponent
from './charts-components/ApplyDocStatisticsOneElementComponent.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    ApplyDocStatisticsOneElementComponent,
    BCardTitle,
  },
  directives: {
    Ripple,
  },
  props: {
    applyDocCount: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    getName(key) {
      switch (key) {
        case 'all_confirmed':
          return {
            name: {
              uz: 'Barchasi',
              ru: 'Все',
              en: 'All',
            },
          }
        case 'dc':
          return this.getDcType(this.DSc)
        case 'phd':
          return this.getDcType(this.PhD)
        case 'trainee':
          return this.getDcType(this.traineeResearcher)
        case 'i_dc':
          return this.getDcType(this.independentResearcherDSc)
        case 'i_phd':
          return this.getDcType(this.independentResearcherPhD)
        case 't_dc':
          return this.getDcType(this.targetedDSc)
        case 't_phd':
          return this.getDcType(this.targetedPhD)
        default:
          return {
            name: {
              uz: '',
              ru: '',
              en: '',
            },
          }
      }
    },
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](id)
    },
  },
  setup() {
    const {
      DSc, PhD, traineeResearcher,
      independentResearcherDSc,
      independentResearcherPhD,
      targetedPhD,
      targetedDSc,
    } = store.state.staticModule

    return {
      DSc,
      PhD,
      traineeResearcher,
      independentResearcherDSc,
      independentResearcherPhD,
      targetedPhD,
      targetedDSc,
    }
  },
}
</script>

<style>
.height-70 {
  height: 70px;
}
</style>
